module.exports = __webpack_public_path__ + "img/company-icon.ad5172b8.svg";